import React from "react";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import { DeviceNameCell } from "../../../../components/table";
import {
  multipleDeviceIdSort,
  multipleThreatsSort,
} from "../../../../components/table/helpers/sorting.helper";
import { DeviceWithType } from "../../../../components/devices/DeviceWithType";
import { Manufacturer } from "../../../../components/manufacturer/Manufacturer";
import { InfectionsList } from "../../../../components/infectionsList/InfectionsList";
import { BlockedDevicesActionsDropdown, TableCard } from "./components";

export const COLUMNS = [
  {
    Header: <FormattedMessage id={"device_name_devices_table_header"} />,
    accessor: "name",
    sortable: true,
    Cell: ({
      row: {
        original: { name },
      },
    }) => <DeviceNameCell name={name} />,
  },
  {
    Header: <FormattedMessage id={"device_id_devices_table_header"} />,
    accessor: "identifiers",
    sortable: true,
    sortType: multipleDeviceIdSort,
    Cell: ({
      row: {
        original: { details },
      },
    }) => {
      return (
        <div>
          {_.map(details, ({ type, identifier }) => (
            <DeviceWithType
              type={type}
              key={identifier}
              identifier={identifier}
            />
          ))}
        </div>
      );
    },
  },
  {
    Header: <FormattedMessage id={"manufacturer_devices_table_header"} />,
    accessor: "manufacturer",
    sortable: true,
    cellClassName: "color-table__cell",
    Cell: ({
      row: {
        original: { manufacturer },
      },
    }) => <Manufacturer manufacturer={manufacturer} />,
  },
  {
    Header: <FormattedMessage id={"infections_devices_table_header"} />,
    accessor: "flatInfections",
    sortable: true,
    sortType: multipleThreatsSort,
    Cell: ({
      row: {
        original: { infections },
      },
    }) => <InfectionsList infections={infections} />,
  },
  {
    id: "actions",
    sortable: false,
    headerClassName: "table__cell--small-cell",
    Header: <FormattedMessage id={"actions"} />,
    cellClassName: "table__cell--center table__cell--overflow",
    Cell: ({
      row: {
        original: { name, identifiers, manufacturer, logicalDeviceId },
      },
    }) => (
      <BlockedDevicesActionsDropdown
        device={{
          name,
          identifiers,
          manufacturer,
          logicalDeviceId,
        }}
        validateImmediately={false}
        isSavedDevice={true}
      />
    ),
  },
];

export const COLUMNS_MOBILE = [
  {
    accessor: "name",
    cellClassName: "table__cell--overflow",
    SortingLabel: <FormattedMessage id={"device_name_devices_table_header"} />,
    Cell: ({
      row: {
        isExpanded,
        original: {
          details,
          manufacturer,
          name,
          infections,
          identifiers,
          logicalDeviceId,
        },
      },
    }) => (
      <TableCard
        isExpanded={isExpanded}
        details={details}
        manufacturer={manufacturer}
        name={name}
        infections={infections}
        identifiers={identifiers}
        logicalDeviceId={logicalDeviceId}
      />
    ),
  },
  {
    accessor: "identifiers",
    sortType: multipleDeviceIdSort,
    SortingLabel: <FormattedMessage id={"device_id_devices_table_header"} />,
  },
  {
    accessor: "manufacturer",
    SortingLabel: <FormattedMessage id={"manufacturer_devices_table_header"} />,
  },
  {
    accessor: "flatInfections",
    sortType: multipleThreatsSort,
    SortingLabel: <FormattedMessage id={"infections_devices_table_header"} />,
  },
];

export const SEARCH_KEYS = [
  "flatInfections",
  "identifiers",
  "manufacturer",
  "name",
];

export const INITIAL_SORT = [{ id: "flatInfections", desc: true }];
